export default __webpack_public_path__ + "static/media/descapitalizar.448f84f2.png";